import { Navigate } from "react-router-dom";
import { AuthGuard } from "@trillion/auth";
import { RootLayout } from "../layouts/root-layout";
import { LoginPage } from "../pages/login";
import { RegisterPage } from "../pages/register";
import { ForgotPasswordPage } from "../pages/forgot-password";
import { ResetPasswordPage } from "../pages/reset-password";
import { AcceptInvitePage } from "../pages/accept-invite";
import { VerifyEmailPage } from "../pages/verify-email";
import { EmailChangeConfirmPage } from "../pages/email-change-confirm";
import { AccountPage } from "../pages/account";
import { OAuthConsentPage } from "../pages/oauth-consent";

export const routes = [
  {
    element: <RootLayout />,
    children: [
      { path: "/", element: <Navigate to="/login" replace /> },
      { path: "/login", element: <LoginPage /> },
      { path: "/oauth/consent", element: <OAuthConsentPage /> },
      { path: "/register", element: <RegisterPage /> },
      { path: "/forgot-password", element: <ForgotPasswordPage /> },
      { path: "/reset-password", element: <ResetPasswordPage /> },
      { path: "/accept-invite", element: <AcceptInvitePage /> },
      { path: "/verify-email", element: <VerifyEmailPage /> },
      { path: "/email-change/confirm", element: <EmailChangeConfirmPage /> },
      {
        element: <AuthGuard />,
        children: [
          { path: "/account", element: <AccountPage /> },
        ],
      },
    ],
  },
];
